import { useFlag } from "@unleash/proxy-client-react";
import { useUnleashConfigured } from "../providers/UnleashProvider";

export function useUnleashFlag(flagName: string): boolean {
  const configured = useUnleashConfigured();
  const flagValue = useFlag(flagName);
  return configured ? flagValue : false;
}
